<script lang="ts" module>
  export const leaderboardModal = new ModalQueryState('leaderboard');
</script>

<script lang="ts">
  import Play from '~icons/mdi/play';
  import Close from '~icons/mdi/close';
  import Home from '~icons/mdi/home';
  import Modal from '~/components/Modal.svelte';
  import ActionButton from '~/components/ActionButton.svelte';
  import { Tabs, TabList, TabPanel, Tab } from '../components/tabs';
  import EntryList from './EntryList.svelte';
  import type { Period } from '~/types';
  import Calendar from '~icons/mdi/calendar';
  import Earth from '~icons/mdi/earth';
  import Person from '~icons/mdi/account';
  import type Icon from '~icons/mdi/calendar';
  import AwardIcon from '~/icons/AwardIcon.svelte';
  import { ModalQueryState } from '~/lib/nav.svelte';
  import { goto } from '$app/navigation';
  import { getGame } from '~/store/GameContext.svelte';
  import { ClassicGame } from '~/store/classic.svelte';
  import { leaderboardPeriod } from './state.svelte';
  const fromHome = $derived(leaderboardModal.value === 'b');
  const game = $derived(getGame<ClassicGame>().current);

  type TabT = {
    desc: string;
    icon: typeof Icon;
  };
  const tabs: Partial<Record<Period, TabT>> = {
    week: {
      desc: 'Weekly',
      icon: Calendar,
    },
    all: {
      desc: 'Global',
      icon: Earth,
    },
    local: {
      desc: 'Personal',
      icon: Person,
    },
  };

  const handlePlay = () => {
    goto('/classic', { shallow: true, replace: true });
  };

  const handleClose = () => {
    leaderboardModal.pop();
  };

  let contentHeight = $state(0);
  // svelte-ignore non_reactive_update
  let selected = {
    get current() {
      return leaderboardPeriod.current;
    },
    set current(value: Period) {
      leaderboardPeriod.current = value;
    },
  };
</script>

<Tabs key="leaderboard-tabs" bind:selected>
  <Modal
    id="leaderboard"
    virtual
    fullHeight
    index={4}
    open={leaderboardModal.open}
    onClose={handleClose}
  >
    {#snippet title()}
      <div class="title-container">
        <div class="title">
          <AwardIcon size="3em" />
          <h1>Leaderboards</h1>
        </div>
        <TabList>
          {#each Object.entries(tabs) as [name, value]}
            <Tab name={name}>
              <value.icon size={20} />{value.desc}
            </Tab>
          {/each}
        </TabList>
      </div>
    {/snippet}
    {#snippet content()}
      <div class="content" bind:offsetHeight={contentHeight}>
        <TabPanel>
          {#key selected.current}
            <EntryList
              tab={selected}
              listHeight={contentHeight}
              currentGameId={game.id}
              lost={game.lost}
            />
          {/key}
        </TabPanel>
      </div>
    {/snippet}
    {#snippet controls()}
      <ActionButton onClick={handleClose}>
        {#if fromHome}
          <Home />
          Home
        {:else}
          <Close />
          Close
        {/if}
      </ActionButton>
      {#if fromHome}
        <ActionButton onClick={handlePlay}>
          Play Classic
          <Play />
        </ActionButton>
      {/if}
    {/snippet}
  </Modal>
</Tabs>

<style lang="scss">
  :global(#leaderboard .title) {
    margin: 0 auto;
    h1 {
      margin-bottom: 0.25em;
    }
  }
  .title-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    :global(.tab) {
      font-size: 1rem;
    }
  }
  .title {
    font-size: 1rem;
    display: flex;
    h1 {
      margin: 0.5em 0;
    }
    & :global(svg) {
      transform: translateY(1em);
    }
  }
  .content {
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
</style>
